import lightGallery from 'lightgallery';

function lightgalleryGallery() {

    // console.log('lightgalleryGallery');

    // Selecciona todas las galerías con la clase 'module__lg-gallery'
    const galleries = document.querySelectorAll('.lightgallery__gallery');

    // Inicializa lightGallery en cada galería
    galleries.forEach(gallery => {
        lightGallery(gallery, {
            selector: 'a',
            counter: false,
            download: false,
            zoomFromOrigin: false,
            mobileSettings : {
                controls: true,
            }
        });
    });

}

export default lightgalleryGallery;